import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { applyLanguage } from '@fms/ui';
import en from './locales/en.json';
import hi from './locales/hi.json';

/**
 * English + Hindi with English fallback. Form/journey definitions carry their
 * own inline i18n (resolved by the form-engine); these bundles cover the app
 * chrome only.
 *
 * A `?lang=` handover from the sibling admin portal beats the persisted
 * choice: the portals live on different origins, so localStorage cannot carry
 * a selection across — the "Citizen Login" tab's URL is the only channel.
 */
const param = new URLSearchParams(window.location.search).get('lang');
const handover = param === 'en' || param === 'hi' ? param : null;
if (handover) applyLanguage(handover);

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, hi: { translation: hi } },
  lng: handover ?? document.documentElement.getAttribute('lang') ?? 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
